function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#19DED1",
  d: "M1.5 6.83325C1.5 3.79569 3.96243 1.33325 7 1.33325C10.0376 1.33325 12.5 3.79569 12.5 6.83325C12.5 9.87082 10.0376 12.3333 7 12.3333C3.96243 12.3333 1.5 9.87082 1.5 6.83325ZM7 0.333252C3.41015 0.333252 0.5 3.2434 0.5 6.83325C0.5 10.4231 3.41015 13.3333 7 13.3333C10.5899 13.3333 13.5 10.4231 13.5 6.83325C13.5 3.2434 10.5899 0.333252 7 0.333252ZM7 4.99992C6.63181 4.99992 6.33333 4.70144 6.33333 4.33325C6.33333 3.96506 6.63181 3.66658 7 3.66658C7.36819 3.66658 7.66667 3.96506 7.66667 4.33325C7.66667 4.70144 7.36819 4.99992 7 4.99992ZM6.33333 6.33325C6.33333 5.96506 6.63181 5.66658 7 5.66658C7.36819 5.66658 7.66667 5.96506 7.66667 6.33325V8.99992C7.66667 9.36811 7.36819 9.66659 7 9.66659C6.63181 9.66659 6.33333 9.36811 6.33333 8.99992V6.33325Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var SvgIconInfo = function SvgIconInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 14",
    height: 14,
    width: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Info.f2147ef0.svg";
export { ForwardRef as ReactComponent };